import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import ImgProduct from '../../../assets/images/base/product.png';
import { BaseURL } from '../../../base/env';
import { calculator, TComma } from '../../../base/utils';
import { Box, Image, Note, Uniter } from '../../../helbest';
import { API } from '../../../request/api';
import { _Cart_Add, _Cart_Decrease, _Cart_Remove } from '../../../store/actions/cart_actions';
import Plum from './Plum/Plum';

const CartItem = ({ data }) => {
  const [disabled, setDisabled] = useState(false);
  const store = useSelector((state) => state);
  const dispatch = useDispatch();

  const history = useHistory();

  const getQuantity = () => {
    if (!Array.isArray(store.Cart)) {
      return 0;
    }
    const fp = store.Cart.find((product) => product.id === data.id);
    if (fp) {
      return fp.quantity;
    }
    return 0;
  };

  const add_to_cart = () => {
    const quantity = getQuantity();
    setDisabled(true);
    const cart = Array.isArray(store.Cart) ? store.Cart : [];
    API.post
      .card(data.id, store.Login.city_id, quantity + data.count_step, cart)
      .then((response) => {
        if (response.success) {
          dispatch(_Cart_Add(data));
          calculator();
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      })
      .finally(() => {
        setDisabled(false);
      });
  };

  const decrease = () => {
    dispatch(_Cart_Decrease(data.id));
    calculator();
  };

  const remove_cart_item = () => {
    const new_cart = [];
    const cart = Array.isArray(store.Cart) ? [...new Set(store.Cart)] : [];
    cart.map((x) => (x.id !== data.id ? new_cart.push(x) : null));
    dispatch(_Cart_Remove(new_cart));
    calculator();
    if (new_cart.length === 0) {
      history.push('/');
    }
  };

  return (
    <Box className="component-cart-item" id={`product-${data.id}`}>
      <div className="cart-item-box ws-100 mar-b-10">
        <div className="cart-item-box-data">
          <span className="cart-item-box-title mar-b-10">{data.name}</span>
          <Uniter className="cart-item-box-price" unit="تومان">
            {data.item_payable_amount}
          </Uniter>
          <div className="cart-item-box-discount-box">
            {data.payable_amount !== data.price ? (
              <Uniter className="cart-item-box-discount">{data.item_price}</Uniter>
            ) : null}
            {data.discount_amount ? (
              <span className="slide-off-percent">
                {data.visible_discount_type === 'fixed'
                  ? TComma(data.item_fixed_discount_amount)
                  : `${data.discount_percentage} %`}
              </span>
            ) : null}
          </div>
        </div>

        <div className="cart-item-image-container">
          {!data.auction ? (
            <Image alt={data.id} fallback={ImgProduct} src={BaseURL + data.image} />
          ) : null}
        </div>
      </div>

      <div className="ws-100">
        <Plum
          disabled={disabled}
          onMinus={data.quantity <= data.count_step ? remove_cart_item : decrease}
          onPlus={add_to_cart}
          trash={data.quantity <= data.count_step}>
          {`${data.quantity} ${data.unit}`}
        </Plum>
        <Uniter className="cart-item-box-price" unit="تومان">
          {data.payable_amount * data.quantity}
        </Uniter>
      </div>
      {data.auction ? <div className="cart-item-auction-label">بسته حراجی</div> : null}
    </Box>
  );
};

CartItem.propTypes = {
  data: PropTypes.string
};

export default CartItem;
